/** Reduce fotos antes de subir (evita 413: base64 JSON + límite hosting). */
export async function compressImageFile(
  file,
  { maxSide = 1200, quality = 0.82, maxBytes = 900 * 1024 } = {}
) {
  if (!file || !/^image\//i.test(file.type || '')) {
    throw new Error('Archivo de imagen no válido');
  }

  const dataUrl = await readFileAsDataUrl(file);
  const img = await loadImage(dataUrl);
  let { width, height } = img;
  const scale = Math.min(1, maxSide / Math.max(width, height));
  width = Math.max(1, Math.round(width * scale));
  height = Math.max(1, Math.round(height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return file;
  ctx.drawImage(img, 0, 0, width, height);

  let q = quality;
  let blob = await canvasToBlob(canvas, 'image/jpeg', q);
  while (blob && blob.size > maxBytes && q > 0.4) {
    q -= 0.07;
    blob = await canvasToBlob(canvas, 'image/jpeg', q);
  }
  if (!blob) return file;

  const base = String(file.name || 'foto').replace(/\.[^.]+$/, '') || 'foto';
  return new File([blob], `${base}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
}

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('No se pudo leer la imagen'));
    reader.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('No se pudo procesar la imagen'));
    img.src = src;
  });
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), type, quality);
  });
}

export async function fileToCompressedDataUrl(file) {
  const prepared = await compressImageFile(file);
  return readFileAsDataUrl(prepared);
}
